import React from 'react'
import styled from 'styled-components'
import { FaMapMarkerAlt } from 'react-icons/fa'
import { useEvent } from '../event-details'
import { SidebarButtonLink } from './sidebar-button'
import SidebarSectionLabel from './sidebar-section-label'

const LocationMeta = styled.dl`
  margin-top: 0;
`

const EventLocation = () => {
  const event = useEvent()
  if (!event) return null

  let directionsParams = `destination=${encodeURI(event.location.address)}`
  if (event.location.googlePlaceId) {
    directionsParams += `&destination_place_id=${encodeURI(event.location.googlePlaceId)}`
  }

  return (
    <section>
      <SidebarSectionLabel>Location</SidebarSectionLabel>

      <LocationMeta>
        <dt>
          <FaMapMarkerAlt title="Location" />
        </dt>
        <dd>{event.location.name}</dd>
      </LocationMeta>

      <SidebarButtonLink
        as="a"
        href={`https://www.google.com/maps/dir/?api=1&${directionsParams}&travelmode=driving`}
        rel="noopener"
        target="_blank"
        variant="outlined"
      >
        Get <b>Directions</b>
      </SidebarButtonLink>
    </section>
  )
}

export default EventLocation
